import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ProfilePermissions } from '../models/profile.models';
import { PermissionService } from './permission.service';
import {AdalService} from 'adal-angular4';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(public adal: AdalService,
    private router: Router,
    private permissionsService: PermissionService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.adal.userInfo.authenticated) {
      return true;
      // debugger;
      // if(!route.data['auth'])
      //   return true;
      // else if(route.data['auth'] && this.hasRequiredPermission(route.data['auth'])) {
      //   return true;
      // } else {
      //   this.router.navigate(['/']);
      //   return false;
      // }
    }
    this.router.navigate(['/']);
    return false;
  }

  protected hasRequiredPermission(authGroup: ProfilePermissions): Promise<boolean> | boolean {
    if (authGroup) {
        return this.permissionsService.hasPermission(authGroup);
    } else {
        return this.permissionsService.hasPermission(null);
    }
  }
}
